var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin",
    d: "M9.313-7.312a6.464,6.464,0,0,1,1.375.875,3.84,3.84,0,0,1,.953,1.2A3.218,3.218,0,0,1,12-3.75a.723.723,0,0,1-.219.531A.723.723,0,0,1,11.25-3H7V.25a.277.277,0,0,1-.031.125l-.75,1.5a.254.254,0,0,1-.437,0l-.75-1.5A.277.277,0,0,1,5,.25V-3H.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,0-3.75,3.227,3.227,0,0,1,.75-5.812a5.387,5.387,0,0,1,1.938-1.5L3.063-11H1.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,1-11.75v-1.5a.723.723,0,0,1,.219-.531A.723.723,0,0,1,1.75-14h8.5a.723.723,0,0,1,.531.219A.723.723,0,0,1,11-13.25v1.5a.723.723,0,0,1-.219.531A.723.723,0,0,1,10.25-11H8.938Z",
    transform: "translate(0 14)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.029d0bd8a801d9daa8cc48aa43ab8d03.svg";
export { ForwardRef as ReactComponent };